/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <k.pawlak@giap.pl>, February 2026
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import RodoContent from '../../components/RodoContent/RodoContent';
import AttachmentsPanel from '../../components/AttachmentsPanel/AttachmentsPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import { isMobileView, isTabletView, renderHelpDesc, isSuperAdminRole } from '../../components/utils/utils';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import agentConfig from './agent';
import loadingData from './loading';
import { trackEvent } from '../../lib/utils';
import ButtonsPanel from './utils/ButtonsPanel';
import { showDraftsCondition, saveDraft, areEqual, getDraft, getDraftDataFromState } from '../../components/DraftManagement/draftManager';
import waiting from '../paymentStatus/waiting-wheel-300x300.gif';
import { btnStyle, bodyStyle, redirectToSummary } from './constants';

import v from './validators';


const dzialkaDict = {
  miejscowosc: {
    label: 'Miejscowość',
    editable: true,
  },
};

const stateToDraft = [
  "dzialka",
  "info",
  "selectedParcels",
  "selectedRoads",
  "attachments",
];


class UstalenieNumeruPorzadkowego extends React.Component {
  state = {
    dzialka: {
      miejscowosc: null,
    },
    info: {
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    acceptRODO: false,
    attachments: null,
    draftAttachments: null,
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
    showDrafts: false,
  };

  validators = {
    miejscowosc: [v.NotNull],
    agentAdd: [v.NotSelected],
  };

  onHide = () => this.setState({ showError: false });

  async componentDidMount() {
    const showDrafts = showDraftsCondition(this.props.prefix);
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
          showDrafts: showDrafts,
        }, () => this.updateValidators());
      });

    if (showDrafts) {
      const draftData = await getDraft(this.props.prefix, this.props.serviceInfo.eservice.shortName);

      if (draftData) {
        this.setState({ ...draftData, draftAttachments: draftData.attachments, isMounted: true }, () => {
          window.dispatchEvent(
            new CustomEvent("draft:loaded")
          );
        });
      } else {
        this.setState({ isMounted: true });
      }
    } else {
      this.setState({
        isMounted: true
      })
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showDrafts) {
      if (!this.state.isMounted) return;

      if (!prevState.isMounted && this.state.isMounted) return;

      const prevDraft = getDraftDataFromState(prevState, stateToDraft);
      const currentDraft = getDraftDataFromState(this.state, stateToDraft);

      if (this.props.serviceInfo.user && !areEqual(prevDraft, currentDraft)) {
        saveDraft(
          currentDraft,
          this.props.prefix,
          this.props.serviceInfo.eservice.shortName
        );
      }
    }
  }

  handleManualDraftSave = () => {
    const draft = getDraftDataFromState(this.state, stateToDraft);

    saveDraft(
      draft,
      this.props.prefix,
      this.props.serviceInfo.eservice.shortName,
      { debounce: false } // wymuszony zapis
    );
  };

  updateValidators = () => {
    if (this.state.info.agentAdd === 'TAK') {
      this.validators.agentName = [v.NotNull];
      this.validators.agentAddress = [v.NotNull];
      this.validators.agentPostOffice = [v.NotNull];
      this.validators.agentPostalCode = [v.NotNull];
      this.validators.agentPhoneNumber = [v.NotNull];
      this.validators.agentMotionAddress = [v.NotNull];
    } else {
      this.validators.agentName = [];
      this.validators.agentAddress = [];
      this.validators.agentPostOffice = [];
      this.validators.agentPostalCode = [];
      this.validators.agentPhoneNumber = [];
      this.validators.agentMotionAddress = [];
    }
  }

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name, this.updateValidators),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name, this.updateValidators),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['dzialka', 'info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }

    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  hasErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      dzialka: {
        miejscowosc: "Miejscowość testowa",
      }
    });
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.hasErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
      return;
    }
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          info: { ...this.state.info },
          dzialka: { ...this.state.dzialka },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () => {
              trackEvent({
                category: 'application',
                action: 'click',
                name: this.props.serviceInfo.eservice.title,
              });
              redirectToSummary(resp.jobId);
            }
          );
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);

    if (!this.state.isMounted) {
      return (
        <GrayPanel
          title="Trwa ładowanie zawartości..."
          bodyStyle={bodyStyle}
        >
          <img alt="Loader" src={waiting} />
        </GrayPanel>
      );
    }

    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <GrayPanel
          title={'1. Teren'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ fontWeight: 'bold' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }

        <DecisionContainer
            title={'2. Informacje o budynku'}
            data={this.state.dzialka}
            errors={this.state.errors}
            formDict={dzialkaDict}
            onChange={e => this.onChange(e, 'dzialka')}
          ></DecisionContainer>

        <RodoContent prefix={this.props.prefix} />

        <GrayPanel title={'Informacje dodatkowe'} >
          <p>Jeżeli wniosek dotyczy więcej niż jednego budynku lub sytuacja w terenie nie wskazuje jednoznacznie,
            któremu budynkowi ma zostać ustalony numer porządkowy – do wniosku należy dołączyć mapę lub szkic z ich
            lokalizacją i oznaczeniem.
          </p>
        </GrayPanel>

        <AttachmentsPanel
          onChangeAttachments={this.onChangeAttachments}
          showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}
          draftAttachments={this.state.draftAttachments}
        />

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <ButtonsPanel
          prefix={this.props.prefix}
          shortName={this.props.serviceInfo.eservice.shortName}
          serviceTitle={this.props.serviceInfo.eservice.title}
          showDrafts={this.state.showDrafts}
          onDraftSave={this.handleManualDraftSave}
          onSave={() => this.setState({ loading: true }, () => this.startService())}
          onCancel={history.goBack}
        />

        <div className="col-sm-12">
          {(this.props.serviceInfo.user && isSuperAdminRole(this.props.serviceInfo.user.roles)) ? (
            <button
              type="submit-lg"
              className="btn btn-success"
              style={{ float: 'left', marginRight: '15px', ...btnStyle }}
              onClick={this.insertTestData}
            >
              Insert Test Data
            </button>
          ) : null}
        </div>
      </div>
    );
  }
}

UstalenieNumeruPorzadkowego.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(UstalenieNumeruPorzadkowego),
);



// WEBPACK FOOTER //
// src/routes/eservices/UstalenieNumeruPorzadkowego.js